import { Alert } from '@simplywallst/ui-core';

type Props = {
  errorStatusCode: number;
};

export const LinkingError = ({ errorStatusCode }: Props) => {
  if (errorStatusCode === 403 || errorStatusCode === 401) {
    return (
      <Alert styleType="negative">
        Invalid login details, please try again.
      </Alert>
    );
  }

  return (
    <Alert styleType="negative">
      Something went wrong! Please try to connect with your brokerage again.
    </Alert>
  );
};
